import { BaseLookupModel, PaginationFilterRequest } from "./core.model";

export interface DiscoveryPoint {
    id: number;
    name: string;
    imageUrl?: string;
    objUrl?: string;
    lat: number;
    lon: number;
    radius: number;
    cityId: number;
    city: BaseLookupModel;
    hasAchievement: boolean;
}

export interface UpsertDiscoveryPoint {
    id?: number;
    name?: string;
    imageUrl?: string;
    objUrl?: string;
    lat?: number;
    lon?: number;
    radius?: number;
    cityId?: number;
}

export class DiscoveryPointPaginationFilterRequest extends PaginationFilterRequest{  
    cityId?: number;
    countryId?: number;
}
